import React, { Component } from "react";
import { connect } from "react-redux";
import CustomLoader from "../../forms/Loader";
import {
  agentEmpanelementRegistration,
  checkEmpanelementStatus,
} from "../../../store/actions/nps";
import Signbutton from "../../forms/button";

import { SucesssPopUp } from "../customModal";
import {
  ADITYA_POP_CODE,
  ADITYA_POP_SP_CODE,
  HDFC_POP_CODE,
  HDFC_POP_SP_CODE,
  ICICI_POP_CODE,
  ICICI_POP_SP_CODE,
  NPS_URL,
} from "./index";
import { errorCodes } from "./errorCodes";
const BUILD_URL = process.env.PUBLIC_URL;
class EmpanelementSummary extends Component {
  constructor(props) {
    super(props);
    const BasicDetails = this.props.Nps_Basic_Details;
    const BankDetails = this.props.Nps_Bank_Details;
    const { Bank } = BasicDetails;
    this.state = {
      body: {
        POP_Code:
          Bank === "HDFC"
            ? HDFC_POP_CODE
            : Bank === "ICICI"
            ? ICICI_POP_CODE
            : ADITYA_POP_CODE,
        POP_SP_Code:
          Bank === "HDFC"
            ? HDFC_POP_SP_CODE
            : Bank === "ICICI"
            ? ICICI_POP_SP_CODE
            : ADITYA_POP_SP_CODE,
        jsonstring: {
          Agent_Empanelment_details: {
            AEM_POP_Code:
              Bank === "HDFC"
                ? HDFC_POP_CODE
                : Bank === "ICICI"
                ? ICICI_POP_CODE
                : ADITYA_POP_CODE,
            AEM_POP_SP_Code:
              Bank === "HDFC"
                ? HDFC_POP_SP_CODE
                : Bank === "ICICI"
                ? ICICI_POP_SP_CODE
                : ADITYA_POP_SP_CODE,
            AEM_Name: BasicDetails.Name,
            AEM_PAN: BasicDetails.PAN,
            AEM_ARN_Number: BasicDetails.Arn,
            AEM_Email_ID: BasicDetails.Email_Id,
            AEM_MobileNo: BasicDetails.MobileNo,
            AEM_RegisteredAddress: BasicDetails.Address2 || "",
            AEM_RegisteredAddressCity: BasicDetails.City2 || "",
            AEM_RegisteredAddressState: BasicDetails.State2.value || "",
            AEM_RegisteredAddressPincode: BasicDetails.Pincode2 || "",
            AEM_CorrespondenceAddress: BasicDetails.Address,
            AEM_CorrespondenceAddressCity: BasicDetails.City,
            AEM_CorrespondenceAddressState: BasicDetails.State.value,
            AEM_CorrespondenceAddressPincode: BasicDetails.Pincode,
            AEM_BankAccountNumber: BankDetails.AccountNumber,
            AEM_BankIFSC: BankDetails.IFSC,
            AEM_BankName: BankDetails.BankName,
            AEM_BankBranch: BankDetails.Branch,
            AEM_BankAddress: BankDetails.Branch,
            AEM_NO_Customers: BasicDetails.Customers,
            AEM_NO_Experience: BasicDetails.Experience,
            AEM_Source: "DIT",
          },
          Document_details: [
            {
              AED_DocImage: this.props.location.state.PAN.AED_DocImage,
              AED_DocType: "PAN",
              AED_DocName: this.props.location.state.PAN.AED_DocName,
            },
            {
              AED_DocImage: this.props.location.state.ADCR.AED_DocImage,
              AED_DocType: "ADCR",
              AED_DocName: this.props.location.state.ADCR.AED_DocName,
            },
            {
              AED_DocImage: this.props.location.state.CHQ.AED_DocImage,
              AED_DocType: "CHQ",
              AED_DocName: this.props.location.state.CHQ.AED_DocName,
            },
            {
              AED_DocImage: this.props.location.state.ADPR.AED_DocImage,
              AED_DocType: "ADPR",
              AED_DocName: this.props.location.state.ADPR.AED_DocName,
            },
          ],
        },
      },
      Message: "",
      open: false,
      submitbtn: true,
      checkbox: true,
      loading: false,
      fail: false,
    };
  }

  redirect = () => {
    if (!this.state.fail) {
      this.props.history.push(NPS_URL + "/onlineEmpanelement/status", {
        Message: this.state.Message,
      });
    } else {
      this.setState({
        open: false,
      });
    }
  };
  submit = async () => {
    if (this.state.submitbtn || this.state.checkbox) {
      alert(
        "Please Read and Accept the Terms and Conditions to proceed further"
      );
      return;
    }
    this.setState({
      loading: true,
    });
    const response = await this.props.agentEmpanelementRegistration(
      this.state.body
    );
    this.setState({
      loading: false,
    });

    const responseBody = !!response.body
      ? JSON.parse(response.body.replace("/", ""))
      : "";
    if (!!responseBody) {
      const Message = !!responseBody.Status
        ? responseBody.Status[0].Message
        : "Invalid Licence Key";
      const errors = !!responseBody.Details
        ? responseBody.Details[0].FL_errorcode.split(",")
        : [];

      const errorMessage =
        errors.length === 1
          ? errorCodes[errors[0]]
          : errors.length > 0
          ? errors.reduce(
              (previous, current) =>
                errorCodes[previous] + "," + errorCodes[current]
            )
          : "";

      this.setState({
        Message: `${Message}.  ` + errorMessage,
        open: true,
        fail:
          !!errorMessage || Message === "Invalid Licence Key" ? true : false,
      });
    } else {
      this.setState({
        Message:
          "Something Went wrong with the submission, Please Try again Later",
        open: true,
        fail: true,
      });
    }
  };

  render() {
    const BasicDetails = this.props.Nps_Basic_Details;
    const BankDetails = this.props.Nps_Bank_Details;
    const { Bank } = BasicDetails;
    return (
      <div className="container-margin">
        <CustomLoader display={this.state.loading} />
        <SucesssPopUp
          closeSucessModal={this.redirect}
          response={this.state.Message}
          open={this.state.open}
          isNps={true}
          fail={this.state.fail}
        />
        <div className="customer-support-email">
          Customer Support Email :{" "}
          <a href="mailto:npsdistributorsupport@kfintech.com">
            npsdistributorsupport@kfintech.com
          </a>
        </div>
        <h4 style={{ margin: "20px" }}>Summary</h4>
        <div className="nps-forms">
          <div className="nps-forms-header">
            <h6 style={{ marginTop: "7.5px" }}>Basic Details</h6>
          </div>
          <div style={{ display: "flex" }}>
            <div className="nps-summary">
              <p style={{ margin: "20px" }}>
                Name* :
                <span style={{ fontWeight: "500" }}> {BasicDetails.Name}</span>
              </p>
              <p style={{ margin: "20px" }}>
                Registered Address:
                <span style={{ fontWeight: "500" }}>
                  {BasicDetails.Address2 || "-"}
                </span>
              </p>
              <p style={{ margin: "20px" }}>
                Mobile*:
                <span style={{ fontWeight: "500" }}>
                  {BasicDetails.MobileNo}
                </span>
              </p>
            </div>
            <div className="nps-summary">
              <p style={{ margin: "20px" }}>
                PAN*:{" "}
                <span style={{ fontWeight: "500" }}>{BasicDetails.PAN}</span>
              </p>
              <p style={{ margin: "20px" }}>
                Correspondence Address*:
                <span style={{ fontWeight: "500" }}>
                  {BasicDetails.Address}
                </span>
              </p>
              <p style={{ margin: "20px" }}>
                Email Id*:
                <span style={{ fontWeight: "500" }}>
                  {BasicDetails.Email_Id}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="nps-forms">
          <div className="nps-forms-header">
            <h6 style={{ marginTop: "7.5px" }}>Bank Details</h6>
          </div>
          <div style={{ display: "flex" }}>
            <div className="nps-summary">
              <p style={{ margin: "20px" }}>
                Bank Account Number* :{" "}
                <span style={{ fontWeight: "500" }}>
                  {" "}
                  {BankDetails.AccountNumber}
                </span>
              </p>
              <p style={{ margin: "20px" }}>
                Bank Name*:{" "}
                <span style={{ fontWeight: "500" }}>
                  {" "}
                  {BankDetails.BankName}
                </span>
              </p>
            </div>
            <div className="nps-summary">
              <p style={{ margin: "20px" }}>
                IFSC*:{" "}
                <span style={{ fontWeight: "500" }}> {BankDetails.IFSC}</span>
              </p>
              <p style={{ margin: "20px" }}>
                Branch*:{" "}
                <span style={{ fontWeight: "500" }}> {BankDetails.Branch}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="nps-forms">
          <div className="nps-forms-header">
            <h6 style={{ marginTop: "7.5px" }}>Documents</h6>
          </div>
          {this.state.body.jsonstring.Document_details.length > 0 &&
            this.state.body.jsonstring.Document_details.map((e) => (
              <div>
                <div className="nps-summary">
                  <p>
                    {e.AED_DocType === "PAN"
                      ? "PAN*"
                      : e.AED_DocType === "ADCR"
                      ? "ARN Certificate*"
                      : e.AED_DocType === "ADPR"
                      ? "Address Proof*"
                      : e.AED_DocType === "CHQ"
                      ? "Cancelled Cheque*"
                      : e.AED_DocType}
                  </p>
                  <div
                    style={{
                      margin: "20px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      height: "60px",
                      padding: "12px",
                    }}
                  >
                    <p>{e.AED_DocName} </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div
          className="dual-margin"
          style={{
            marginBottom: "10px",
            marginTop: "30px",
            marginLeft: "20px",
          }}
        >
          <input
            type="checkbox"
            style={{ display: "inline", marginRight: "20px" }}
            onChange={(event) =>
              event.target.checked
                ? this.setState({ checkbox: false })
                : this.setState({ checkbox: true })
            }
          />
          {"I Agree to the "}
          <a
            href={`${BUILD_URL}/nps/tnc/${
              Bank === "HDFC" ? "hdfc" : Bank === "ICICI" ? "icici" : "aditya"
            }`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              this.setState({ submitbtn: false });
            }}
          >
            Terms and Conditions*
          </a>
        </div>
        <div style={{ marginLeft: "20px" }}>
          <Signbutton buttontitle="Submit" onClick={this.submit} width="50%" />
        </div>
        <br />
        <div className="input-margin flex">
          <div className="appbar-div dual-margin mouse-pointer ">
            <span
              className="input-name"
              onClick={() =>
                this.props.history.push(NPS_URL + "/onlineEmpanelement/upload")
              }
              style={{
                color: "#007bff",
                marginTop: "20px",
              }}
            >
              {"Back to upload page"}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  ({ npsReducer }) => {
    const { Nps_Basic_Details, Nps_Bank_Details } = npsReducer;
    return { Nps_Basic_Details, Nps_Bank_Details };
  },
  { agentEmpanelementRegistration, checkEmpanelementStatus }
)(EmpanelementSummary);
